'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { type PropsWithChildren, useEffect, useRef } from 'react';
import { RoutingContext } from '@/contexts/routingContext';
export const RoutingProvider = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastPageRef = useRef(null);
  const previousPathname = useRef(null);
  let t1;
  let t2;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t1 = () => {
      if (previousPathname.current && previousPathname.current !== pathname) {
        lastPageRef.current = {
          pathname: previousPathname.current,
          search: searchParams.toString()
        };
      }
      previousPathname.current = pathname;
    };
    t2 = [pathname, searchParams];
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== router) {
    t3 = () => {
      if (lastPageRef.current) {
        router.push(lastPageRef.current.pathname + (lastPageRef.current.search ? `?${lastPageRef.current.search}` : ""));
      } else {
        history.back();
      }
    };
    $[4] = router;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const back = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => !!lastPageRef.current;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const isLastPageAvailable = t4;
  let t5;
  if ($[7] !== back) {
    t5 = {
      back,
      canGoBack: isLastPageAvailable
    };
    $[7] = back;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = <RoutingContext.Provider value={t5}>{children}</RoutingContext.Provider>;
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};